/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { gaugeAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type UnstakeLiquidityProps = {
  account: Address
  chainId: number
  config: Config
  gaugeAddress: Address
  amount: bigint
}

export const unstakeLiquidity = async ({
  account,
  chainId,
  config,
  gaugeAddress,
  amount,
}: UnstakeLiquidityProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: gaugeAbi as Abi,
        account,
        address: gaugeAddress,
        args: [amount],
        chainId,
        functionName: "withdraw",
      },
    })
    return result
  } catch (error: any) {
    console.error("unstakeLiquidity", error)
    return { success: false, error: error.message, code: error.code }
  }
}
